export default {
  // 主机类型
  optSystemTypes: [
    { name: 'Linux', value: 'Linux' },
    { name: 'Windows', value: 'Windows' }
  ],
  netTypes: [
    { name: 'OA', value: '1' },
    { name: 'DMZ', value: '2' },
    { name: '经典', value: '3' },
    { name: 'VPC', value: '4' },
    { name: '研发区', value: '5' },
    { name: '测试区', value: '6' },
    { name: '运维管理区', value: '7' }
  ],
  status: [
    { name: '运行中', value: 'Running' },
    { name: '已关机', value: 'closed' },
    { name: '已释放', value: 'released' }
  ],
  HIDSStatus: [
    { name: '正常', value: 'Running' },
    { name: '离线', value: 'closed' },
    { name: '未安装', value: 'released' }
  ],
  months: [
    { name: '01', value: '1' },
    { name: '02', value: '2' },
    { name: '03', value: '3' },
    { name: '04', value: '4' },
    { name: '05', value: '5' },
    { name: '06', value: '6' },
    { name: '07', value: '7' },
    { name: '08', value: '8' },
    { name: '09', value: '9' },
    { name: '10', value: '10' },
    { name: '11', value: '11' },
    { name: '12', value: '12' }
  ],
  accountRulesTypes: {
    0: '计费规则说明',
    1: '计算',
    2: '块存储',
    3: '对象存储',
    4: '文件存储',
    5: '态势感知',
    6: '计算节点',
    7: '数据存储',
    8: '服务器托管'
  },
  IOInstances: [
    { name: 'optimized', value: 'optimized' },
    { name: 'none', value: 'none' }
  ],
  sysPanTypes: [
    { name: 'ESSD云盘', value: 'cloud_essd' },
    { name: '高效云盘', value: 'cloud_efficiency' },
    { name: 'SSD云盘', value: 'cloud_ssd' },
    { name: '普通云盘', value: 'cloud' }
  ],
  billingMethods: [
    { name: 'PrePaid', value: 'PrePaid' },
    { name: 'PostPaid', value: 'PostPaid' }
  ]
}



// WEBPACK FOOTER //
// ./src/assets/utilits/enumList.js